<template>
  <div>
    <h4>Relais Mobile</h4>
    <v-simple-table>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-left">Nom</th>
          <th class="text-left">Performance</th>
          <th class="text-left">Slots</th>
          <th class="text-left">Requêtes en cours</th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="relay in relays"
          :key="'mobile-relay-' + relay.id"
        >
          <td>{{ relay.id }}</td>
          <td>
            <v-chip small dark :color="relay.latency < 40 ? 'success' : 'orange'">
              {{ relay.slot_performance }} %
            </v-chip>
          </td>
          <td>{{ relay.slot_count * relay.slot_factor }}</td>
          <td></td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: 'RouterMobileRelays',
  props: ['telemetry'],
  computed: {
    relays () {
      try {
        return this.telemetry.transport['mobile-relay']
      } catch (e) {
        return []
      }
    }
  }
}
</script>

<style scoped>

</style>